import R from 'ramda'

// Update a folder's sharedSchools and/or sharedUsers arrays
export function adjustFolderShares({ folder, myFolders }) {
  const existingFolderIndex = R.findIndex(R.propEq('id', folder.id), myFolders)

  if (existingFolderIndex < 0) {
    throw new Error(
      `updateSharedFolder: Folder with id ${folder.id} not found in myFolders`
    )
  }

  const { sharedSchools, sharedUsers } = folder

  return R.adjust(
    existingFolderIndex,
    R.mergeLeft({ sharedSchools, sharedUsers }),
    myFolders
  )
}

// Remove any school and/or user IDs from a folder's sharedSchools and sharedUsers arrays
export function removeFolderShares({ folderId, myFolders }) {
  const existingFolderIndex = R.findIndex(R.propEq('id', folderId), myFolders)

  if (existingFolderIndex < 0) {
    throw new Error(
      `removeFolderShares: Folder with id ${folderId} not found in myFolders`
    )
  }

  return R.adjust(
    existingFolderIndex,
    R.mergeLeft({ sharedSchools: [], sharedUsers: [] }),
    myFolders
  )
}
